module.exports = __webpack_public_path__ + "static/logo-196f7f4960e4182aff33deedc520809e.png";